import { render, staticRenderFns } from "./CatalogoIndex.vue?vue&type=template&id=ba1d9a32"
import script from "./CatalogoIndex.vue?vue&type=script&lang=js"
export * from "./CatalogoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports